module.exports = __webpack_public_path__ + "static/media/Porygon2_gaussian2.e5ac6bd3.png";